import { useSession } from '@clerk/clerk-react';
import { API_URL } from 'constants/index';
import { useEffect, useState } from 'react';
import { fetchWithAuth } from 'shared/api/fetch-with-auth';

const useWhatsAppTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const { session } = useSession();

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await fetchWithAuth(`${API_URL}/whatsapp/templates`, { method: 'GET' }, session);
        const data = await response.json();
        console.log("Received templates", data);
        setTemplates(data);
      } catch (error) {
        console.error('Error fetching WhatsApp templates:', error);
      }
    };

    fetchTemplates();
  }, []);

  return templates;
};

export default useWhatsAppTemplates;